import React from 'react';

import HeaderApp from 'components/Header/HeaderApp';
import Bottom from 'components/Bottom';
import ContentDeliveryMaterials from './ContentDeliveryMaterials';

const DeliveryMaterials = () => {
  return (
    <div className="d-flex flex-column min-h-screen">
      <HeaderApp />
      <ContentDeliveryMaterials />
      <Bottom />
    </div>
  );
};

export default DeliveryMaterials;
